'use strict';
const angular = require('angular');
const {isFunction} = angular;

export const DomainBootstrapperImport = [
  '$injector',
  '$q',
  function (
    $injector,
    $q,
  ) {
    var DomainBootstrapper = {};
    var relationalBootstrapQueue = [];
    var applicationIsLoaded = false;
    var loadedDeferred = $q.defer();

    // Run Configuration

    DomainBootstrapper.init = function initDomainBootstrapper() {
      //console.log('Initializing domain module. Adding %s relationships.', relationalBootstrapQueue.length);
      applicationIsLoaded = true;
      processQueue();
      loadedDeferred.resolve();
    };

    DomainBootstrapper.queue = function queueDomainBootstrapper(command) {
      if (isFunction(command)) {
        relationalBootstrapQueue.push(command);
      } else {
        throw new Error('Invalid Domain Class relationship definition: ', command);
      }

      if (applicationIsLoaded) {
        setTimeout(function () {
          processQueue();
        });
      }
    };

    DomainBootstrapper.loaded = function loadedDomainBootstrapper() {
      return loadedDeferred.promise;
    };

    function processQueue() {
      while (relationalBootstrapQueue.length) {
        relationalBootstrapQueue.pop()($injector);
      }
    }

    return DomainBootstrapper;
  }];

export const DomainBootstrapperRun = ['DomainBootstrapper', function (DomainBootstrapper) {
  setTimeout(function () {
    DomainBootstrapper.init();
  });
}];



// WEBPACK FOOTER //
// ./src/js/_libs/angular-domain/DomainBootstrapper.js